module.exports = __webpack_public_path__ + "static/media/icon_rick_1.122824e9.svg";